export enum Flags {
  FLAG_1774_ONETRUST = "FLAG_1774_ONETRUST",
  FLAG_1953_SHOW_BUTTON_DESCRIPTION = "FLAG_1953_SHOW_BUTTON_DESCRIPTION",
  FLAG_2022_WIDGET_LIVECHAT_ALFAVOX_CALLBACK = "FLAG_2022_WIDGET_LIVECHAT_ALFAVOX_CALLBACK",
  FLAG_2039_VIDEO = "FLAG_2039_VIDEO",
  FLAG_2071_OWU_IPID = "FLAG_2071_OWU_IPID",
  FLAG_1552_ACCEPT_POLICY = "FLAG_1552_ACCEPT_POLICY",
  FLAG_2316_PAYU = "FLAG_2316_PAYU",
}
